import { Container, Button, Form, Alert } from 'react-bootstrap';
import { Sida, Rubrik, ContentWrapper } from "../ContentStyles";

import useBackend, { CallAPI, SpinnerX } from '../../services/useBackend';

import React, { useState, useEffect } from 'react';

import { Branding } from '../../services/misc';

import "./Contact.scss"

const Contact = () => {

    const [resultText, setResultText] = useState("N/A");
    const [resultVariant, setResultVariant] = useState("notset");
    const [resultVisible, setResultVisible] = useState(false);
    const [spinnerHidden, setSpinnerHidden] = useState(true);

    // const [size, setSize] = useState({
    //     x: window.innerWidth,
    //     y: (window.innerHeight - 400)
    // });

    // const updateSize = () => {
    //     setSize({
    //         x: window.innerWidth,
    //         y: (window.innerHeight - 400)
    //     });
    // }
    // useEffect(() => (window.onresize = updateSize), []);
    // useEffect(() => (window.onscroll = updateSize), []);

    async function handleSubmit(e) {
        e.preventDefault();

        setSpinnerHidden(false);
        setResultVisible(false);

        const formData = new FormData(e.target),
            formDataObj = Object.fromEntries(formData.entries())

        var PostData = { SystemID: "NS", FormData: formDataObj };

        let { resultVariant, resultVisible, resultText, jsondata } = await CallAPI('/backend/forms/contact', 'POST', JSON.stringify(PostData));

        if (jsondata.errorsException === false) {
            setResultVariant(resultVariant);
            setResultText(resultText);
            setSpinnerHidden(true);
            setResultVisible(true);
        } else {
            setResultVariant("warning");
            setResultText(resultText);
            setSpinnerHidden(true);
            setResultVisible(true);
        }
    }

    return (
        <ContentWrapper className="contact-page">
            <div className="contact-page__bg" aria-hidden="true">
                <div className="contact-page__blob contact-page__blob--a" />
                <div className="contact-page__blob contact-page__blob--b" />
            </div>

            <Container>
                <Sida className="contact-page__layout">
                    <div className="contact-card">
                        <Rubrik className="contact-card__title">
                            Kontakta oss eller boka demo
                        </Rubrik>



                        <Form onSubmit={handleSubmit} className="contact-form">
                            <Form.Group className="mb-3">
                                <Form.Control
                                    className="contact-input"
                                    type="text"
                                    name="Name"
                                    placeholder="Namn"
                                    disabled={resultVariant == "success" ? true : false}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Control
                                    className="contact-input"
                                    type="email"
                                    name="Email"
                                    placeholder="Email"
                                    disabled={resultVariant == "success" ? true : false}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Control
                                    className="contact-input"
                                    type="text"
                                    name="Subject"
                                    placeholder="Ämne"
                                    disabled={resultVariant == "success" ? true : false}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Control
                                    className="contact-input contact-textarea"
                                    as="textarea"
                                    rows={6}
                                    name="Text"
                                    placeholder="Fråga"
                                    disabled={resultVariant == "success" ? true : false}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" hidden={spinnerHidden}>
                                <div className="contact-spinner">
                                    <SpinnerX />
                                </div>
                            </Form.Group>

                            <Form.Group className="mb-3" hidden={!resultVisible}>
                                <Alert
                                    show={resultVisible}
                                    variant={resultVariant}
                                    className="contact-alert"
                                >
                                    {resultText}
                                </Alert>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Button
                                    className="contact-submit"
                                    variant="primary"
                                    type="submit"
                                    disabled={resultVariant == "success" ? true : false}
                                >
                                    Skicka
                                </Button>
                            </Form.Group>
                        </Form>
                    </div>
                </Sida>
            </Container>
        </ContentWrapper>
    );
}

export default Contact;